/**
 * Escapes HTML-special characters so that user-controlled text can be safely
 * interpolated into raw HTML strings (e.g. Bryntum tooltip/renderer templates,
 * which bypass React's automatic escaping).
 *
 * This is the render-sink half of the defence-in-depth against stored XSS in the
 * Planner hover tooltips: even if unsanitised HTML reaches the client, escaping it
 * here prevents it from executing when the tooltip HTML is parsed by the browser.
 */
export function escapeHtml(value: string): string {
  if (value == null) {
    return '';
  }

  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
